import React from 'react';

import './PaypalInfo.css';

export default function PayPalInfo({ email = '' }) {
  if (!email) return null;

  return (
    <div className="paypalInfo">
      <img
        className="paypalThumb"
        src="/account/static/images/cards/paypal-logo-01.svg"
        width="73"
        height="17"
        alt="PayPal"
      />
      <span className="paypalEmail" data-heap-redact-text>
        {email}
      </span>
    </div>
  );
}
